import MetaHeader from '@buddieshr/components/metaHeader';
import { useRouter } from 'next/router';
import Header from '@buddieshr/components/header';
import Footer from '@buddieshr/components/footer';
import { BuildVsBuy, FooterCTA } from '@buddieshr/components/landing/sections';
import {
  BvBHero,
  BvBAIBuild,
  BvBTrueCost,
  BvBTimeline,
  BvBIceberg,
  BvBSwitcherQuote,
} from '@buddieshr/components/buildVsBuy/sections';

export default function BuildVsBuyPage({ refSource }) {
  const router = useRouter();

  return (
    <>
      <MetaHeader
        title="Build vs. Buy your employee engagement tools | BuddiesHR"
        description="“I'll just have Claude build it this afternoon.” The honest long version: what an in-house Slack/Teams engagement bot really costs over twelve months, and why teams end up buying."
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/build-vs-buy`}
        locale={router.locale}
        pageSlug="build-vs-buy"
      />
      <Header />
      <main className="bh">
        <BvBHero />
        <BvBAIBuild />
        <BuildVsBuy />
        <BvBTrueCost />
        <BvBTimeline />
        <BvBIceberg />
        <BvBSwitcherQuote />
        <FooterCTA />
      </main>
      <Footer refSource={refSource} />
    </>
  );
}
